import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { studyTutorInput } from "./study-tutor-input";
import { campaignEnvironment } from "./email-reactivation-policy";

/** Observes the existing tutor's actual response, never a client success claim. */
export const processEmailCampaignQuestion = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator(input => studyTutorInput.parse(input))
  .handler(async ({ context, data }) => {
    const { requestId, client: _client, ...body } = data;
    const { data: answer, error } = await context.supabase.functions.invoke("solve-problem", { body });
    if (error) throw new Error("The tutor could not complete this question. Please try again.");
    // The legacy endpoint remains responsible for authentication, AI modes and quotas.
    if (data.action === "solve" && answer && !answer.error && typeof answer.finalAnswer === "string" && Array.isArray(answer.steps)) {
      try {
        const environment = campaignEnvironment(new URL(getRequest().url).hostname);
        const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
        const { data: allowed } = await supabaseAdmin.rpc("email_campaign_account_allowed", { _user_id: context.userId });
        const { data: cohort } = await supabaseAdmin.from("email_campaign_returns").select("user_id").eq("user_id", context.userId).eq("environment", environment).gte("expires_at", new Date().toISOString()).maybeSingle();
        if (allowed && cohort) await supabaseAdmin.from("email_campaign_answers").insert({ user_id: context.userId, request_id: requestId, environment });
      } catch { /* Reporting failure must not discard a completed answer. */ }
    }
    return answer as Record<string, any>;
  });